import * as React from 'react';
import { OpenDataPaymentForm } from '../../components/OpenDataPaymentForm';
import { useDispatch, useSelector } from 'react-redux';
import { checkEstimationExists, resetCheckEstimationExists } from '../../actions/checkEstimationExists';
import { bindActionCreators } from 'redux';
import { selectFilters } from '../../selectors/selectFilters';
import { selectCheckEstimationExists } from '../../selectors/checkEstimationExists/selectCheckEstimationExists';
import { openDataPaymentForm } from '../../actions/dataPayment';

export const OpenDataPaymentFormContainer: React.FC = () => {
  const { isNotFound, isFetching } = useSelector(selectCheckEstimationExists);
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters);

  const boundActions = React.useMemo(
    () =>
      bindActionCreators(
        {
          checkEstimationExists,
          resetCheckEstimationExists,
          openDataPaymentForm,
        },
        dispatch,
      ),
    [dispatch],
  );

  React.useEffect(() => {
    boundActions.resetCheckEstimationExists();
  }, [filters.address, filters.roomsCount, filters.area, boundActions]);

  const handleClick = React.useCallback(async () => {
    const isEstimationExists = await ((boundActions.checkEstimationExists() as unknown) as Promise<boolean>);

    if (isEstimationExists) {
      boundActions.openDataPaymentForm();
    }
  }, [boundActions]);

  return (
    <OpenDataPaymentForm
      onClick={handleClick}
      isLoading={isFetching}
      disabled={isNotFound}
      isNotFound={isNotFound}
      submitText="Далее"
    />
  );
};

OpenDataPaymentFormContainer.displayName = 'OpenDataPaymentFormContainer';
